// src/features/learner/components/ContentRenderers/InteractiveImageViewer.js
import React, { useState } from 'react';
import { InteractiveImageRenderer } from './InteractiveImageRenderer';

const InteractiveImageViewer = ({ unit }) => {
    const [selectedHotspot, setSelectedHotspot] = useState(null);
    const [visitedHotspots, setVisitedHotspots] = useState(new Set());

    const handleHotspotClick = (hotspot) => {
        setSelectedHotspot(hotspot.id);
        setVisitedHotspots(prev => new Set(prev).add(hotspot.id));
    };

    const handleSetSelectedHotspot = (id) => {
        setSelectedHotspot(id);
    };

    return (
        <InteractiveImageRenderer
            unit={unit}
            selectedHotspot={selectedHotspot}
            visitedHotspots={visitedHotspots}
            onHotspotClick={handleHotspotClick}
            onSetSelectedHotspot={handleSetSelectedHotspot}
        />
    );
};

export default InteractiveImageViewer;